/* eslint-disable */
import React from "react";
import { cn } from "../../lib/utils";
import {
  IconCurrencyDollar,
  IconShieldCheck,
  IconBrain,
  IconWorld,
  IconUserCheck,
  IconHeadset,
  IconRocket,
  IconHeart,
} from "@tabler/icons-react";

const features = [
  {
    title: "Zero Platform Fees",
    description:
      "Freelancers keep 100% of their earnings. No hidden fees, no surprises—just fair pay for great work.",
    icon: <IconCurrencyDollar />,
  },
  {
    title: "Secure Escrow Protection",
    description:
      "Every payment is held in secure escrow until work is approved. Pay confidently, get paid reliably.",
    icon: <IconShieldCheck />,
  },
  {
    title: "AI-Powered Matching",
    description:
      "Our intelligent algorithms connect you with the perfect match. Less searching, more working.",
    icon: <IconBrain />,
  },
  {
    title: "Global Payout Options",
    description:
      "Bank transfers, mobile money, PayPal, crypto—get paid your way in 50+ African countries.",
    icon: <IconWorld />,
  },
  {
    title: "Verified Top Talent",
    description:
      "Every freelancer is pre-vetted through ID verification, skills tests, and portfolio reviews.",
    icon: <IconUserCheck />,
  },
  {
    title: "24/7 Dedicated Support",
    description:
      "Real humans ready to help. From onboarding to disputes, our team has your back.",
    icon: <IconHeadset />,
  },
  {
    title: "Fast Project Launch",
    description:
      "Post a job and get matched with qualified talent within 24 hours. Start building faster.",
    icon: <IconRocket />,
  },
  {
    title: "Built for Africa",
    description:
      "Purpose-built for African talent with local compliance, timezone advantages, and EOR services.",
    icon: <IconHeart />,
  },
];

export function FeaturesSectionWithHoverEffects() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-primary">CareerBuddyPro</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're not just another freelancing platform. We're building the future of work for African talent.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 relative z-10">
          {features.map((feature, index) => (
            <Feature key={feature.title} {...feature} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

const Feature = ({
  title,
  description,
  icon,
  index,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col lg:border-r py-10 relative group/feature border-gray-200",
        (index === 0 || index === 4) && "lg:border-l border-gray-200",
        index < 4 && "lg:border-b border-gray-200"
      )}
    >
      {index < 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-green-50 to-transparent pointer-events-none" />
      )}
      {index >= 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-green-50 to-transparent pointer-events-none" />
      )}
      <div className="mb-4 relative z-10 px-10 text-primary">
        {React.cloneElement(icon, { size: 32, stroke: 1.5 })}
      </div>
      <div className="text-lg font-bold mb-2 relative z-10 px-10">
        <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-gray-200 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
        <span className="group-hover/feature:translate-x-2 transition duration-200 inline-block text-gray-900">
          {title}
        </span>
      </div>
      <p className="text-sm text-gray-600 max-w-xs relative z-10 px-10">
        {description}
      </p>
    </div>
  );
};

export default FeaturesSectionWithHoverEffects;
